var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox", staticStyle: { "padding-bottom": "0" } },
    [
      _c(
        "el-row",
        { staticClass: "baseInfo", attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c("div", { staticClass: "acea-row row-between-wrapper" }, [
                    _c("div", { staticClass: "acea-row align-center" }, [
                      _c("span", { staticClass: "main_tit" }, [
                        _vm._v("总数据"),
                      ]),
                    ]),
                  ]),
                  _vm.viewData
                    ? _c("div", { staticClass: "container" }, [
                        _c("div", { staticClass: "con_left" }, [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock m-b-15" },
                            [_vm._v(_vm._s(_vm.viewData.userNum || 0))]
                          ),
                          _c("span", { staticClass: "main_tit" }, [
                            _vm._v("用户总数"),
                          ]),
                        ]),
                        _c("div", { staticClass: "line" }),
                        _c("div", { staticClass: "con_right" }, [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock m-b-15" },
                            [_vm._v(_vm._s(_vm.viewData.merchantNum || 0))]
                          ),
                          _c("span", { staticClass: "main_tit" }, [
                            _vm._v("商户总数"),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("今日新增商户数"),
                        ]),
                      ]),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _vm.viewData
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock my15" },
                            [
                              _vm._v(
                                _vm._s(_vm.viewData.todayNewMerchantNum || 0)
                              ),
                            ]
                          ),
                          _c("el-divider"),
                          _c(
                            "div",
                            { staticClass: "acea-row row-between-wrapper" },
                            [
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v("昨日数据"),
                              ]),
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.viewData.yesterdayNewMerchantNum || 0
                                  ) + " 人"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("今日新增用户数"),
                        ]),
                      ]),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _vm.viewData
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock my15" },
                            [_vm._v(_vm._s(_vm.viewData.todayNewUserNum || 0))]
                          ),
                          _c("el-divider"),
                          _c(
                            "div",
                            { staticClass: "acea-row row-between-wrapper" },
                            [
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v("昨日数据"),
                              ]),
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.viewData.yesterdayNewUserNum || 0
                                  ) + " 人"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("订单量"),
                        ]),
                      ]),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _vm.viewData
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock my15" },
                            [_vm._v(_vm._s(_vm.viewData.orderNum || 0))]
                          ),
                          _c("el-divider"),
                          _c(
                            "div",
                            { staticClass: "acea-row row-between-wrapper" },
                            [
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v("昨日数据"),
                              ]),
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v(
                                  _vm._s(_vm.viewData.yesterdayOrderNum || 0) +
                                    "单"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("用户访问量"),
                        ]),
                      ]),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _vm.viewData
                    ? _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "content-number spBlock my15" },
                            [_vm._v(_vm._s(_vm.viewData.pageviews || 0))]
                          ),
                          _c("el-divider"),
                          _c(
                            "div",
                            { staticClass: "acea-row row-between-wrapper" },
                            [
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v("昨日数据"),
                              ]),
                              _c("span", { staticClass: "content-time" }, [
                                _vm._v(
                                  _vm._s(_vm.viewData.yesterdayPageviews || 0)
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-between-wrapper" },
                    [
                      _c("div", { staticClass: "acea-row align-center" }, [
                        _c("span", { staticClass: "main_tit" }, [
                          _vm._v("销售额"),
                        ]),
                      ]),
                      _c("el-tag", { attrs: { type: "primary" } }, [
                        _vm._v("今日"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "span",
                        { staticClass: "content-number spBlock my15" },
                        [_vm._v(_vm._s(_vm.viewData.sales || 0))]
                      ),
                      _c("el-divider"),
                      _c(
                        "div",
                        { staticClass: "acea-row row-between-wrapper" },
                        [
                          _c("span", { staticClass: "content-time" }, [
                            _vm._v("昨日数据"),
                          ]),
                          _c("span", { staticClass: "content-time" }, [
                            _vm._v(
                              _vm._s(_vm.viewData.yesterdaySales || 0) + " 元"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }